import { useAuthContext } from "../Contexts/AuthProvider";

import NewNotificationIndicator from '../NewNotificationIndicator';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { IconButton } from "@mui/material";

import styles from "./Header.module.css";
import { Link, useNavigate } from "react-router-dom";
import UserAvatar from "../UserAvatar";
import NavMenu from "./NavMenu";
import MenuIcon from '@mui/icons-material/Menu';
import ProfileModal from "../Profile/ProfileModalTailwind";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";

const Header = () => {
  const [userModalOpen, setUserModalOpen] = useState(false);

  const navigate = useNavigate();
  const { user } = useAuthContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const elementRef = useRef<HTMLDivElement | null>(null);

  const handleAvatarClick = () => {
    if (!user) return;

    setUserModalOpen(true); return;
  }

  const getNavMenuItems = () => {
    let ret: any[] = [];

    if (user) {
      //ret.push({ path: '/history', label: 'History' });
      //      ret.push({ path: '/archive', label: 'Archived Drafts' });
    }

    //    if (hasPrivilege('read_free_script')) {
    //      ret.push({ path: '/scriptlibrary', label: 'Script Library' });
    //    }

    //    if (hasPrivilege('template')) {
    //      ret.push({ path: '/templates', label: 'Writing Templates' });
    //    }

    //    if (hasPrivilege('audio_library')) {
    //      ret.push({ path: '/audiolibrary', label: 'Audio Library' });
    //    }

    return ret;
  }

  return (
    <>
      <div ref={elementRef} className={styles["sticky-header"]} id='sticky-header'>
        <div className={styles["topbar"]}>
          <a className={styles["logo"]} href="https://www.vactors.club"><span className={styles["bracket-left"]}>[</span>VACTORS<span className={styles["bracket-right"]}>]</span></a>
          <div className={styles["header-actions"]}>
            <div id="header-actions" />
            {user ?
              <IconButton onClick={handleAvatarClick}
                sx={{ border: '1px solid rgba(255, 255, 255, 0.12)', padding: '0px' }}
              >
                <UserAvatar user={user} sx={{
                  width: { 'xs': '38px', 'md': '38px' },
                  height: { 'xs': '38px', 'md': '38px' },
                  fontSize: '.78rem'
                }} />
              </IconButton>
              :
              null
            }

            <NavMenu sx={{
              width: '38px',
              height: '38px',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              background: 'rgba(255, 255, 255, .06)',
            }} iconElement={<MenuIcon sx={{ color: '#F7F4FF', fontSize: '1.1rem' }} />} mobile={isMobile} items={getNavMenuItems()} />
          </div>
        </div>
        <div className={styles["search-panel"]} id="searchPanel">
          <input aria-label="Search script library" id="librarySearch"
            placeholder="Search by title, writer, genre or role..." type="search" />
        </div>
        {user &&
          <nav className={styles["app-menu"]} style={{ position: 'relative' }}>
            <Link to="/scripts" className={window.location.pathname === '/scripts' ? styles.active : ''}>Scripts</Link>
            <Link to="/friends" className={window.location.pathname === '/friends' ? styles.active : ''}>Friends</Link>
            <div style={{ position: 'relative', display: 'flex' }}>
              <Link to="/notifications" style={{ height: '100%', display: 'inline-flex' }} className={window.location.pathname === '/notifications' ? styles.active : ''}
                onClick={() => {
                  if (window.location.pathname === '/notifications') {
                    navigate(0);
                  }
                }}
              >Messages</Link>

              <NewNotificationIndicator color={window.location.pathname === '/notifications' ? 'red' : theme.palette.theme.main} />
            </div>
          </nav>
        }
      </div>

      {user && userModalOpen &&
        <ProfileModal userId={user.id} onClose={() => setUserModalOpen(false)} />
      }
    </>
  )
  /*
  return (
    <>
      <GradientLine />
      <div className={styles.body}>
        <div className={styles.topbar}>
          <Logo href="/" dark={false} />
          <div className={styles["right-icons"]}>

            {user ?
              <IconButton onClick={handleAvatarClick}>
                <UserAvatar user={user} sx={{
                  width: { 'xs': '32px', 'md': '32px' },
                  height: { 'xs': '32px', 'md': '32px' },
                  fontSize: '10pt'
                }} />
              </IconButton>
              :
              null
            }

            <NavMenu iconElement={<MenuIcon />} mobile={isMobile} items={getNavMenuItems()} />
          </div>
        </div>

        <nav className={styles.menu}>
          <Link to="/write" className={window.location.pathname === '/write' ? styles.active : ''}>Drafts</Link>
          <Link to="/scripts" className={window.location.pathname === '/scripts' ? styles.active : ''}>Scripts</Link>
          <Link to="/friends" className={window.location.pathname === '/friends' ? styles.active : ''}>Friends</Link>
          <div>
          <Link style={{}} to="/notifications" className={window.location.pathname === '/notifications' ? styles.active : ''}
          onClick={() => {
            if(window.location.pathname === '/notifications') {
              navigate(0);
            }
          }}
          >Messages</Link>

          <NewNotificationIndicator color={window.location.pathname === '/notifications' ? 'white' : theme.palette.theme.main} />
          </div>
        </nav>
      </div>

      {user && userModalOpen &&
        <ProfileModal userId={user.id} onClose={() => setUserModalOpen(false)} />
      }
    </>
  );
  */
}

export default Header;
